function Footer() {
  return (
    <footer className="border-t border-[#1F2A44]/60 mt-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div>
          <div className="text-[13px] font-semibold text-slate-300">CloudCalculators</div>
          <p className="text-[11px] text-slate-500 mt-1 max-w-md leading-relaxed">
            Illustrative public list-price comparisons for AWS, Azure, GCP and Oracle OCI. Not affiliated with any provider. Always verify with native billing for production decisions.
          </p>
        </div>
        <div className="flex flex-wrap gap-x-5 gap-y-2 text-[11px] font-mono text-slate-500">
          <span>www.cloudcalculators.com</span>
          <a href="#" className="hover:text-cyan-300 transition-colors">Privacy</a>
          <a href="#" className="hover:text-cyan-300 transition-colors">Terms</a>
          <a href="#" className="hover:text-cyan-300 transition-colors">Contact</a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
